import { errorResponse, successResponse } from './utils/response-templates.js';
import { z } from './utils/zod.js';
export const kycRedirectResponseSchema = successResponse().extend({
    url: z.string(),
});
export const kycRedirectBadRequestResponseSchema = errorResponse('Error generating the authorization URL');
export const kycVerifyRequestSchema = z.object({
    code: z.string(),
    type: z.enum(['webid', 'eideasy']),
});
export const kycRedirectRequestSchema = z.object({
    provider: z.string(),
});
export const kycResponseSchema = successResponse();
export const kycBadRequestResponseSchema = errorResponse('The request body is invalid');
export const webidSexSchema = z.enum(['male', 'female', 'diverse', 'unknown']);
export const webidAddressSchema = z.object({
    street: z.string().min(1),
    streetNo: z.string().min(1),
    zip: z.string().min(1),
    city: z.string().min(1),
    country: z.string().min(2).max(2),
});
export const webidStartRequestSchema = z.object({
    dateOfBirth: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be ISO YYYY-MM-DD'),
    sex: webidSexSchema,
    cell: z.string().regex(/^\+\d{6,18}$/, 'Must be E.164 mobile (e.g. +43660...)'),
    address: webidAddressSchema,
});
